import { validateString } from 'avilatek-utils';
import { Period } from '../../models';

export function validatePeriodForm({
  target,
  criterias,
  startDate,
  endDate,
  unitTime,
  name,
}: Partial<Period>): string {
  if (!validateString(name) && name !== '') {
    return 'Debes ingresar un nombre';
  }
  if (criterias.length === 0) {
    return 'Debes ingresar al menos una recompensa';
  }

  if (!unitTime) {
    return 'Debes ingresar una unidad de tiempo';
  }

  if (!target || target < 0) {
    return 'Debes ingresar un objetivo mayor a cero';
  }
  const rewards = criterias?.map((criteria) => criteria.reward);
  if (rewards?.some((reward) => reward === null || reward < 0)) {
    return 'Debes ingresar recompensas positivas';
  }

  const intervals = criterias?.map((criteria) => [
    criteria.lowerRange,
    criteria.upperRange,
  ]);

  // Copy the intervals array and pop the last element of the list and assign it to a new variable using the spread operator
  const userWrittenIntervals = [...intervals];
  userWrittenIntervals.pop();

  if (
    userWrittenIntervals.some((interval) =>
      interval.some((num) => num === null || num < 0)
    )
  ) {
    return 'Debes ingresar todos los rangos como un valor mayor que cero';
  }

  if (
    userWrittenIntervals.some(
      (interval) => interval[0] === interval[1] || interval[0] > interval[1]
    )
  ) {
    return 'El limite inferior no puede ser mayor o igual al limite superior';
  }

  function validBoundries() {
    const boundries = intervals.map((interval) => interval[1]);
    return boundries.every((num, i) =>
      i === boundries.length - 1 ? true : num === intervals[i + 1][0]
    );
  }

  if (!validBoundries() && intervals.length > 1) {
    return 'El límite superior de cada rango debe ser igual al límite inferior del siguiente rango';
  }

  // the rewards array needs to be sequential ordered but accepting zeros in every position except the last one
  function isValidRewards(arr: number[]): boolean {
    if (arr[arr.length - 1] === 0) {
      return false;
    }
    return arr.every(
      (num, i) =>
        i === arr.length - 1 || // If it's the last element, it can be zero
        num < arr[i + 1] || // If it's not the last element, it has to be less than the next one
        num === 0 // If it's not the last element, it can be zero
    );
  }

  // rewards has to be an array of numbers sequentially ordered
  if (!isValidRewards(rewards)) {
    return 'Las recompensas deben ser ingresadas de forma ascendente';
  }

  function validDate(dateToParse: string): boolean {
    const date = new Date(dateToParse);
    return date instanceof Date && !Number.isNaN(date.getTime());
  }

  if (!validDate(startDate) || !validDate(endDate)) {
    return 'Debes ingresar fechas válidas';
  }

  if (new Date(startDate) >= new Date(endDate)) {
    return 'La fecha de inicio debe ser menor a la fecha de fin';
  }

  return '';
}
